import { render } from "./ShowKartu.vue?vue&type=template&id=dc126ede&scoped=true"
import script from "./ShowKartu.vue?vue&type=script&lang=js"
export * from "./ShowKartu.vue?vue&type=script&lang=js"

import "./ShowKartu.vue?vue&type=style&index=0&id=dc126ede&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc126ede"]])

export default __exports__